<template>
  <div data-grm-comp="RoomTestbankViewInfo" class="w-64">
    <div class="room-exam-view-info">
      <div class="bg-indigo-50 flex justify-center items-center">
        <RoomExamTimer class="w-full" />
      </div>
      <div class="room-exam-view-info-body">
        <div class="room-exam-view-info-contents">
          <div class="room-exam-view-info-contents-header">
            <GrmCheckbox id="showAnswer" v-model="_showAnswer">{{ $t("testBank.info.showAnswer") }}</GrmCheckbox>
          </div>
          <perfect-scrollbar class="min-h-0 flex-1">
            <div class="room-exam-view-info-contents-body">
              <RoomExamInfoForm :users="progressUsers">{{ $t("testBank.info.ongoing") }}</RoomExamInfoForm>
              <RoomExamInfoForm :users="completedUsers">{{ $t("testBank.info.submitComplete") }}</RoomExamInfoForm>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
      <div class="room-exam-view-info-footer">
        <div class="room-exam-view-button-wrapper">
          <button class="room-exam-view-button finish" @click="onClickFinish">{{ $t("common.quit") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

import GrmCheckbox from "@/components/Common/input/GrmCheckbox.vue";
import RoomExamTimer from "@/components/Room/Testbank/View/RoomExamTimer.vue";
import RoomExamInfoForm from '@/components/Room/Exam/Info/RoomExamInfoForm.vue';
import {cloneDeep} from "lodash";

export default {
  name: 'TestbankViewInfo',
  components: {
    GrmCheckbox,
    RoomExamTimer,
    RoomExamInfoForm,
  },
  computed: {
    ...mapState('exam', [
      'showAnswer',
      'roomExamUsersAnswerObj',
    ]),

    _showAnswer: {
      get() {
        return this.showAnswer;
      },
      set() {
        this.TOGGLE_SHOW_ANSWER();
      }
    },
    progressUsers() {
      const progressUsers = cloneDeep(this.roomExamUsersAnswerObj);
      for (const userId in progressUsers) {
        const user = progressUsers[userId];
        if (user.completed) {
          delete progressUsers[userId];
        }
      }
      return progressUsers;
    },
    completedUsers() {
      const completedUsers = cloneDeep(this.roomExamUsersAnswerObj);
      for (const userId in completedUsers) {
        const user = completedUsers[userId];
        if (!user.completed) {
          delete completedUsers[userId];
        }
      }
      return completedUsers;
    },
  },
  methods: {
    ...mapActions('exam', [
      'endExam',
    ]),
    ...mapMutations('exam', [
      'TOGGLE_SHOW_ANSWER',
    ]),

    onClickFinish() {
      this.$alert({
        title: this.$t('testBank.info.finish'),
        text: this.$t('testBank.info.finishText'),
        ok: () => {
          this.endExam();
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.room-exam-view-info {
  height: 100%;
  box-shadow: -10px 0 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}
.room-exam-view-info-body {
  min-height: 0;
  flex: 1;
  background-color: rgba(240, 240, 248, 0.94);
}
.room-exam-view-info-contents {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.room-exam-view-info-contents-header {
  height: 46px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.room-exam-view-info-contents-body {}
.room-exam-view-info-footer {}
.room-exam-view-button-wrapper {}
.room-exam-view-button {
  width: 100%;
  height: 60px;
  text-align: center;
  font-size: 21px;
  color: #fff;
  &.finish {
    background: #4f4e5b url('~@/assets/images/flag.svg') no-repeat center left 20px / 20px auto;
  }
  &:hover {
    background-color: #ff005a;
  }
}

// Component
.room-exam-view-info-form-component {
  &::v-deep {
    &:first-child {
      .room-exam-view-state-form {
        border-top: 0;
      }
    }
    .room-exam-view-state-form {
      border-top: 1px solid rgba(0, 0, 0, 0.2);
    }
  }
}
</style>